/**
 * Zentrale AL-SEO-Defaults (bigfollow.al — Storefront Shqipëri).
 * Spiegelt AT_SEO_DEFAULTS / IT_SEO_DEFAULTS. Wird nur konsumiert, wenn
 * useStorefront().storefront === 'al'. CH/AT/IT bleiben unberührt.
 *
 * Zahlungen auf AL: Karte, Link, Apple/Google Pay, PayPal — KEIN TWINT,
 * kein Klarna, kein EPS. Texte enthalten daher niemals "TWINT".
 */
export const AL_SEO_DEFAULTS = {
  // `title` geht als Prop an <SEOHead>; SEOHead hängt " | BigFollow" an.
  title: 'Blej Followers Shqiptar — Instagram & TikTok',
  description:
    'Blej ndjekës, pëlqime dhe shikime për Instagram dhe TikTok. Pagesë e sigurt me kartë ose PayPal. Dorëzim i shpejtë në Shqipëri.',
  heroTitle: 'Blej Followers — Instagram & TikTok',
  heroSubtitle: 'Rrit Instagram dhe TikTok shpejt',
  heroText:
    'Ndjekës realë dhe cilësorë, pëlqime, shikime dhe komente — të dorëzuara brenda pak minutash, me pagesë të sigurt me kartë ose PayPal. E thjeshtë dhe e besueshme për Shqipërinë.',
} as const;
